<template>
  <default-dialog @input="closeForm()" :value="enabled" :title="dialogTitle">
    <template slot="rightButton">
      <v-btn @click="submit" text>Salvar</v-btn>
    </template>
    <v-form ref="form" v-model="valid" style="margin-top: 19px;">
      <v-text-field
        v-model="title"
        required
        :error-messages="titleErrorMessage"
        :counter="titleMaxLength"
        :rules="[formRules.required, formRules.title]"
        :label="'Título'"
        :placeholder="''"
      />
      <v-textarea
        v-model="description"
        auto-grow
        xs12
        required
        :counter="descriptionMaxLength"
        :rules="[formRules.description]"
        :label="'Descrição breve'"
        :placeholder="''"
        :hide-details="'auto'"
        :color="'primary'"
        :rows="'1'"
      />
    </v-form>
  </default-dialog>
</template>

<script>
import DefaultDialog from "@/components/dialogs/Default";
import icons from "@/utils/icons.js";
import { maxLength } from '@/utils/maxLength'
import FormRules from "@/utils/formRules.js";

export default {
  components: { DefaultDialog },
  mixins: [FormRules],
  props: {
    enabled: Boolean,
    currentContents: Array,
    dialogTitle: String,
    type: String
  },

  data: () => ({
    icons,
    valid: true,
    title: "",
    icon: "",
    description: "",
    titleMaxLength: maxLength.title,
    descriptionMaxLength: maxLength.description,
    contentAlreadyExistsError: "Já existe um conteúdo neste capítulo com esse título",
    arrayTypes: { images: 'images', folder: 'files' }
  }),
  computed: {
    titleErrorMessage() {
      let filter = content => content.title === this.title;
      let contentsWithSameTitle = this.currentContents.filter(filter);
      let thisIsANewChapter = contentsWithSameTitle.length === 0;
      let titleErrorMessage = thisIsANewChapter
        ? ""
        : this.contentAlreadyExistsError;
      return titleErrorMessage;
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    submit() {
      this.validate();
      if (this.valid) {
        let { title, description } = this;
        description = description.trim()
        title = title.trim()
        const newContent = { title, description };
        const finder = type => type === this.type
        const contentArray = !!Object.keys(this.arrayTypes).find(finder)
        if(contentArray) {
          const arrayName = this.arrayTypes[this.type] 
          newContent[arrayName] = []
        }
        this.$emit("submit", newContent);
      }
    },

    closeForm() {
      this.reset();
      this.$emit("closed");
    }
  }
};
</script>